/** @format */
import {useLocation, useNavigate} from 'react-router-dom';
import {SelectSearchBy} from '../shared/select_search_by';
import {SearchWithContext} from '../search/search';
import React, {useEffect, useState} from 'react';
import {Tabs, Tab} from '@sttark/design-system';
import {withRouter, If} from 'frontier-utilities';
import {withSearch} from 'frontier-search';

// styles
import './orders_nav.scss';

export const OrdersNav = withRouter(
    withSearch(({children}) => {
        // keep track of grouping state in local storage
        const showGroupedByOrdersKey = 'showGroupedByOrders';

        const [showGroupedByOrders, setShowGroupedByOrders] = useState(false);
        const [activeTab, setActiveTab] = useState();
        const navigate = useNavigate();
        const location = useLocation();

        useEffect(() => {
            if (localStorage.getItem(showGroupedByOrdersKey) !== null) {
                setShowGroupedByOrders(
                    parseInt(localStorage.getItem(showGroupedByOrdersKey)) === 1 ? true : false
                );
            }
        }, []);

        const handleToggleGroupByOrders = () => {
            setShowGroupedByOrders(!showGroupedByOrders);
            localStorage.setItem(showGroupedByOrdersKey, !showGroupedByOrders ? 1 : 0);
        };

        const onChangeTab = tab => {
            navigate(tab);
        };

        // add grouping state to children
        const ChildWithGroupingState = React.cloneElement(children, {showGroupedByOrders});

        useEffect(() => {
            const currentPath = location.pathname;
            setActiveTab(currentPath);
        }, [location]);

        const shouldRenderSearch = location.pathname === '/account/orders/reorders';

        return (
            <section>
                <If condition={shouldRenderSearch}>
                    <div className="reorders_orders-01lw__search d-flex justify-content-between align-items-end">
                        <div className="w-100">
                            <SearchWithContext
                                filter_option_list={[
                                    'filter_order_id',
                                    'filter_width',
                                    'filter_length',
                                    'filter_depth',
                                    'filter_design_id',
                                    'filter_shape_id',
                                    'filter_product_type_id',
                                    'filter_cart_id'
                                ]}
                                placeholder="search order #, filename or shape..."
                            />
                        </div>
                        <div className="flex-shrink-0">
                            <SelectSearchBy
                                handleToggleGroupByOrders={handleToggleGroupByOrders}
                                showGroupedByOrders={showGroupedByOrders}
                            />
                        </div>
                    </div>
                </If>
                <div className="orders-nav-37ju">
                    <Tabs activeTab={activeTab} onChange={onChangeTab} className={'tabs mb-0'}>
                        <Tab title={`Active Orders`} name="/account/orders/index" />
                        <Tab title={`Past Orders`} name="/account/orders/reorders" />
                        {/* TODO: CC has asked to remove this tab from the account. I am giving it a couple weeks before deleting all the related code in case they change their mind*/}
                        {/*<Tab title={`Archived`} name="/account/orders/archived" />*/}
                    </Tabs>
                    {ChildWithGroupingState}
                </div>
            </section>
        );
    })
);
